module.exports = __webpack_public_path__ + "olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.ttf
 ** module id = 45
 ** module chunks = 1
 **/